import { createFileRoute } from "@tanstack/react-router";
import SoilManagement from "@/components/home/SoilManagement";
import useFeatureFlag from "@/lib/featureFlags/useFeatureFlags";
import { useMemo } from "react";
import useFieldDashboard from "@/lib/fieldDashboard/useFieldDashboard";
import { useParams } from "@tanstack/react-router";
import { CropCycleV2 } from "@/types/cropCycle";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/soil-management",
)({
    component: RouteComponent,
});

function RouteComponent() {
    const { soilManagementRequired } = useFeatureFlag();
    const { fieldQuery, selectedCropCycle, cropCycleQueryV2 } =
        useFieldDashboard() ?? {};
    const { fieldId } = useParams({
        from: "/dashboard/fields/$fieldId",
    });
    const fieldWithCropCycle = useMemo(() => {
        return [
            {
                id: Number(fieldId),
                soil_configuration: fieldQuery?.data?.soil_configuration,
                soil_organic_matter: fieldQuery?.data?.soil_organic_matter,
                has_drainage: fieldQuery?.data?.has_drainage,
                typical_N_applied_pounds_per_acre:
                    fieldQuery?.data?.typical_N_applied_pounds_per_acre,
                typical_yield_bushels_per_acre:
                    fieldQuery?.data?.typical_yield_bushels_per_acre,
                crop_cycle: selectedCropCycle as CropCycleV2 | undefined,
            },
        ];
    }, [
        fieldId,
        fieldQuery?.data?.soil_configuration,
        fieldQuery?.data?.soil_organic_matter,
        fieldQuery?.data?.has_drainage,
        fieldQuery?.data?.typical_N_applied_pounds_per_acre,
        fieldQuery?.data?.typical_yield_bushels_per_acre,
        selectedCropCycle,
    ]);

    return (
        <SoilManagement
            fields={fieldWithCropCycle}
            required={soilManagementRequired}
            onFinish={() => {
                cropCycleQueryV2?.refetch();
                fieldQuery?.refetch();
            }}
        />
    );
}
